module.exports = __webpack_public_path__ + "static/media/6C.a722e5a8.svg";